import type * as Types from '../base-types.graphql';

import { gql } from '@apollo/client';
export type GqlCapTableStakeFieldsFragment = { id: string, name: string, kind: number, wiseQuantity?: string | null, stake: string, floor?: string | null, cap?: string | null, investedAmount?: string | null, enabled: boolean, manualEntry: boolean, capTableId: string, identityId: string, createdAt: string, updatedAt: string, comment?: string | null, acqCost?: string | null, value?: string | null, profit?: string | null };

export const CapTableStakeFieldsFragmentDoc = gql`
    fragment CapTableStakeFields on CapTableStake {
  id
  name
  kind
  wiseQuantity
  stake
  floor
  cap
  investedAmount
  enabled
  manualEntry
  capTableId
  identityId
  createdAt
  updatedAt
  comment
  acqCost
  value
  profit
}
    `;